<template>
  <div v-if="hasValidCompletenessPercentage" class="flex flex-col">
    <div class="progress">
      <div class="barOverflow">
        <div ref="bar" class="bar" :class="meterClass"></div>
      </div>
      <span class="percentage-text">
        <span class="bar-text"
          ><strong>{{ completenessPercentage }}% </strong></span
        ><br />
        <span class="text-small">complete</span></span
      >
    </div>
    <div class="flex justify-between -mt-[35px] text-caption">
      <span>&nbsp;0%&nbsp;&nbsp;</span>
      <hr class="percentage-line" :class="meterClass" />
      <span>100%</span>
    </div>
  </div>
</template>

<script lang="ts">
export default {
  name: 'CompletenessMeter',
  props: {
    completenessPercentage: {
      type: Number || null,
      required: false,
      default: null,
    },
    warning: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    hasValidCompletenessPercentage() {
      return typeof this.completenessPercentage === 'number';
    },
    meterClass() {
      if (this.warning) return 'warning';
      if (this.completenessPercentage === 100) return 'completed';
      return '';
    },
  },
  watch: {
    completenessPercentage(newVal: number) {
      const { bar } = this.$refs as { bar: HTMLElement };
      if (bar) bar.style.transform = `rotate(${45 + newVal * 1.8}deg)`;
    },
  },
  mounted() {
    const { bar } = this.$refs as { bar: HTMLElement };
    const p = this.completenessPercentage;
    if (bar) bar.style.transform = `rotate(${45 + p * 1.8}deg)`;
  },
};
</script>

<style lang="scss" scoped>
.progress {
  position: relative;
  margin: 4px;
  float: left;
  text-align: center;
}
.barOverflow {
  /* Wraps the rotating .bar */
  position: relative;
  overflow: hidden;
  width: 145px;
  height: 72.5px; /* Half circle (overflow) */
  margin-bottom: -14px; /* bring the numbers up */
}
.bar {
  position: absolute;
  top: 0;
  left: 0;
  width: 145px;
  height: 145px; /* full circle! */
  border-radius: 50%;
  box-sizing: border-box;
  border: 15px solid #eee;
  border-bottom-color: #005988;
  border-right-color: #005988;
  &.warning {
    border-bottom-color: #a87b00;
    border-right-color: #a87b00;
  }
  &.completed {
    border-bottom-color: #229150;
    border-right-color: #229150;
  }
}

.percentage-text {
  position: relative;
  top: -30px;
}

.percentage-line {
  width: 69.595px;
  height: 1.74px;
  flex-shrink: 0;
  border-radius: 43.497px;
  margin: auto;
  background: #005988;

  &.completed {
    background: #229150;
  }

  &.warning {
    background: #a87b00;
  }
}
.bar-text {
  color: var(--On-surface-Body, #282930);
  text-align: center;
  font-feature-settings:
    'liga' off,
    'clig' off;
  /* Web/Small header */
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  line-height: 28px; /* 140% */
  letter-spacing: 0.107px;
}
</style>
